(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flora-product-extras"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('flora-reviews'))customElements.define('flora-reviews',class extends HTMLElement{
connectedCallback(){this.abort?.abort();this.abort=new AbortController();const o={signal:this.abort.signal};this.track=this.querySelector('.fx__track');if(!this.track)return;const step=()=>this.track.children[0]?.getBoundingClientRect().width+16;const move=d=>{const w=step();if(!w)return;const max=this.track.scrollWidth-this.track.clientWidth;const left=this.track.scrollLeft;this.track.scrollTo({left:d>0&&left>=max-2?0:d<0&&left<=2?max:left+d*w,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};this.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.direction)),o));this.track.addEventListener('keydown',e=>{if(e.target.closest('video,a,button')||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();move(e.key==='ArrowRight'?1:-1);},o);this.track.addEventListener('scroll',()=>{const r=this.track.getBoundingClientRect();this.querySelectorAll('video').forEach(v=>{const p=v.getBoundingClientRect();if(p.right<=r.left||p.left>=r.right)v.pause();});},{...o,passive:true});}
disconnectedCallback(){this.abort?.abort();}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flora-product"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('flora-gallery'))customElements.define('flora-gallery',class extends HTMLElement{
connectedCallback(){
this.abort?.abort();this.abort=new AbortController();const opt={signal:this.abort.signal};
this.track=this.querySelector('.fp__track');this.slides=[...this.querySelectorAll('.fp__slide')];this.buttons=[...this.querySelectorAll('[data-slide]')];
if(!this.track||!this.slides.length)return;
this.index=Math.max(0,this.slides.findIndex(s=>s.dataset.mediaId===this.dataset.initialMedia));
this.buttons.forEach((b,i)=>b.addEventListener('click',()=>this.go(i),opt));
this.track.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1));},opt);
this.track.addEventListener('dragstart',e=>e.preventDefault(),opt);
this.track.addEventListener('pointerdown',e=>{if(!e.isPrimary||e.button!==0||e.target.closest('video,iframe,model-viewer')){this.drag=null;return;}this.drag={id:e.pointerId,x:e.clientX,y:e.clientY};},opt);
window.addEventListener('pointerup',e=>{const d=this.drag;this.drag=null;if(!d||d.id!==e.pointerId)return;const dx=e.clientX-d.x,dy=e.clientY-d.y;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.3)this.go(this.index+(dx<0?1:-1));},opt);
window.addEventListener('pointercancel',()=>this.drag=null,opt);
window.addEventListener('blur',()=>this.drag=null,opt);
this.show();this.setAttribute('data-gallery-ready','');
}
show(){
this.track.style.height='';this.track.scrollLeft=0;
this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;if(i!==this.index)slide.querySelectorAll('video').forEach(v=>v.pause());});
this.buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));
this.revealThumbnail();
}
revealThumbnail(){const button=this.buttons[this.index],rail=button?.parentElement;if(!rail)return;const item=button.getBoundingClientRect(),bounds=rail.getBoundingClientRect();if(item.left<bounds.left||item.right>bounds.right)rail.scrollTo({left:rail.scrollLeft+item.left-bounds.left-(rail.clientWidth-item.width)/2,behavior:'instant'});}
go(index){this.index=(index+this.slides.length)%this.slides.length;this.show();}
disconnectedCallback(){this.abort?.abort();this.drag=null;}
});
if(!customElements.get('flora-product'))customElements.define('flora-product',class extends HTMLElement{
connectedCallback(){this.abort?.abort();this.abort=new AbortController();const opt={signal:this.abort.signal};this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);this.form=this.querySelector('form');this.add=this.querySelector('.fp__buy');this.addEventListener('keydown',()=>this.setAttribute('data-keyboard-focus',''),opt);this.addEventListener('pointerdown',()=>this.removeAttribute('data-keyboard-focus'),opt);this.addEventListener('change',e=>{if(e.target.closest('[data-option]'))this.updateVariant();},opt);this.form?.addEventListener('submit',e=>this.submit(e),opt);if(this.querySelector('.fp__size-select')){this.querySelectorAll('.fp__size-select').forEach(select=>select.selectedIndex=0);this.updateVariant();}}
updateVariant(){this.querySelectorAll(".fp__size-select").forEach(s=>s.parentElement.style.setProperty("--fp-size-width",(s.value.length+6)+"ch"));this.querySelectorAll('.fp__options--photos').forEach(f=>{const label=f.querySelector('[data-color-name]');if(label)label.textContent=f.querySelector('input:checked')?.value||'';});const options=[...this.querySelectorAll('[data-option]')].map(f=>f.querySelector('select')?.value ?? f.querySelector('input:checked')?.value);const v=this.variants.find(v=>v.options.every((x,i)=>x===options[i]));const id=this.form.querySelector('[name=id]');id.value=v?.id||'';id.disabled=!v;if(this.add){this.add.disabled=!v?.available;this.add.textContent=!v?this.add.dataset.unavailableLabel:v.available?this.add.dataset.addLabel:this.add.dataset.soldLabel;}if(!v)return;this.querySelectorAll('[data-price]').forEach(e=>e.textContent=v.price);this.querySelectorAll('[data-compare]').forEach(e=>{e.textContent=v.compare||'';e.hidden=!v.compare;});this.querySelectorAll('[data-sku]').forEach(e=>e.textContent=v.sku||'');const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);const g=this.querySelector('flora-gallery');const i=g?.slides?.findIndex(s=>Number(s.dataset.mediaId)===v.media);if(i>=0)g.go(i);this.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{variant:v}}));}
async submit(e){
if(e.submitter?.name!=='add')return;
e.preventDefault();
if(!this.add||this.add.disabled)return;
const err=this.querySelector('.fp__error');
err.hidden=true;
this.add.disabled=true;
this.add.setAttribute('aria-busy','true');
const root=window.Shopify?.routes?.root||'/';
try{
const drawer=this.add.dataset.cartAction==='cart_drawer'?document.querySelector('cart-drawer'):null;
const useDrawer=drawer&&typeof drawer.renderContents==='function';
const data=new FormData(this.form);
if(useDrawer){
data.set('sections',drawer.getSectionsToRender().map(section=>section.id).join(','));
data.set('sections_url',window.location.pathname);
drawer.setActiveElement(this.add);
}
const response=await fetch(root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
let body=await response.json();
if(!response.ok||body.status)throw Error(body.description||body.message||window.cartStrings.error);
const ready=useDrawer&&drawer.getSectionsToRender().every(section=>typeof body.sections?.[section.id]==='string');
if(ready){
drawer.classList.remove('is-empty');
drawer.renderContents(body);
const items=drawer.querySelector('cart-drawer-items');
if(items)items.inert=true;
try{
if(window.FloraGift){
const result=await window.FloraGift.sync(window.FloraGift.cartFromSections?.(body.sections),drawer.getSectionsToRender().map(s=>s.id));
if(result.sections)drawer.renderContents({...body,sections:result.sections},false);
}
}finally{
const currentItems=drawer.querySelector('cart-drawer-items');
if(currentItems)currentItems.inert=false;
}
}else{
if(window.FloraGift)await window.FloraGift.sync(window.FloraGift.cartFromSections?.(body.sections),[]);
location.assign(root+'cart');
}
}catch(error){
err.textContent=error.message;
err.hidden=false;
}finally{
this.add.removeAttribute('aria-busy');
const selected=this.variants.find(variant=>String(variant.id)===this.form.querySelector('[name=id]').value);
this.add.disabled=!selected?.available;
}
}
disconnectedCallback(){this.abort?.abort();}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flora-sections"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('flora-carousel'))customElements.define('flora-carousel',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const o={signal:this.abort.signal};
  this.track=this.querySelector('.fs__slides');this.track.querySelectorAll('[data-clone]').forEach(e=>e.remove());
  this.cards=[...this.track.children];this.dots=[...this.querySelectorAll('[data-carousel-index]')];this.total=this.cards.length;this.index=0;this.cloneCount=Math.min(this.total,Math.ceil(parseFloat(getComputedStyle(this).getPropertyValue('--fs-slides'))||1));
  if(!this.total)return;
  const clone=c=>{const e=c.cloneNode(true);e.dataset.clone='true';e.setAttribute('aria-hidden','true');e.removeAttribute('data-shopify-editor-block');return e;};
  this.cards.slice(-this.cloneCount).reverse().forEach(c=>this.track.prepend(clone(c)));this.cards.slice(0,this.cloneCount).forEach(c=>this.track.append(clone(c)));
  this.step=()=>this.cards[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(this.track).gap)||0);
  this.reset=()=>{this.track.scrollLeft=(this.cloneCount+this.index)*this.step();this.mark();};requestAnimationFrame(()=>this.reset());
  this.observer=new ResizeObserver(()=>this.reset());this.observer.observe(this.track);
  this.dots.forEach((b,i)=>b.addEventListener('click',()=>this.go(i),o));
  this.track.addEventListener('scroll',()=>{const raw=Math.round(this.track.scrollLeft/this.step())-this.cloneCount;this.index=(raw+this.total)%this.total;this.mark();clearTimeout(this.settle);this.settle=setTimeout(()=>{if(!this.drag&&(raw<0||raw>=this.total))this.reset();},150);},o);
  this.addEventListener('mouseenter',()=>this.hover=true,o);this.addEventListener('mouseleave',()=>this.hover=false,o);
  this.addEventListener('focusin',()=>this.focused=true,o);this.addEventListener('focusout',()=>this.focused=false,o);
  this.track.addEventListener('pointerdown',e=>{this.touching=true;if(e.pointerType==='mouse'&&e.button===0)this.drag={x:e.clientX,start:this.track.scrollLeft};},o);
  window.addEventListener('pointermove',e=>{if(!this.drag)return;const dx=e.clientX-this.drag.x;if(Math.abs(dx)>8){this.track.style.scrollSnapType='none';this.track.scrollLeft=this.drag.start-dx;}},o);
  const finish=()=>{this.touching=false;if(!this.drag)return;this.drag=null;this.track.style.scrollSnapType='';this.go(this.index);};window.addEventListener('pointerup',finish,o);window.addEventListener('pointercancel',finish,o);
  if(this.dataset.auto==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches)this.timer=setInterval(()=>{if(!this.hover&&!this.focused&&!this.touching&&!document.hidden)this.go(this.index+1);},5500);
 }
 mark(){this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)));}
 go(i){this.track.scrollTo({left:(this.cloneCount+i)*this.step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearInterval(this.timer);clearTimeout(this.settle);}
});
if(!customElements.get('flora-countdown'))customElements.define('flora-countdown',class extends HTMLElement{
connectedCallback(){const specified=Date.parse(this.dataset.end);this.end=this.dataset.mode==='fixed'&&Number.isFinite(specified)?specified:Date.now()+Number(this.dataset.hours||12)*3600000;this.tick();this.timer=setInterval(()=>this.tick(),1000);}
tick(){let seconds=Math.max(0,Math.floor((this.end-Date.now())/1000));const h=Math.floor(seconds/3600),m=Math.floor(seconds%3600/60),s=seconds%60;this.querySelector('[data-time]').textContent=[h,m,s].map(v=>String(v).padStart(2,'0')).join(' : ');}
disconnectedCallback(){clearInterval(this.timer);}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flora-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flora-size-guide')) {
  customElements.define('flora-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const trigger = this.querySelector('.flora-size-guide__trigger');
      const dialog = this.querySelector('dialog');
      if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
      trigger.setAttribute('role', 'button');
      const open = (event) => {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      };
      trigger.addEventListener('click', open, options);
      trigger.addEventListener('keydown', (event) => {
        if (event.key === ' ') open(event);
      }, options);
      this.querySelector('.flora-size-guide__close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }), options);
    }
    disconnectedCallback() {
      this.querySelector('dialog')?.close();
      this.abort?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
